module.exports = __webpack_public_path__ + "static/media/text-documents-line.96970707.svg";